export default __webpack_public_path__ + "static/media/zuba-terminal.d8efbf34.png";